export const PAGE_URLS = {
  configuration: "/configuration/customer-banks",
} as const;
